export default __webpack_public_path__ + "static/media/bg_1980.604b5d6b.png";